import { z } from "zod";

export const organizationDemoWorkspaceResponseSchema = z.object({
    demoWorkspace: z
        .object({
            id: z.string().uuid(),
            name: z.string(),
        })
        .nullable(),
});
